import store from '../../../../../src/store';
import ShopifyAdapterService from '../../../../../src/services/shopify/ShopifyAdapterService';

/**
 * Current service is called from vue component,
 * vue component is rendered before App.init()
 */
class OrderPageService {
  handle() {
    const pageType = 'order';
    if (store.getters['shopify/page/type'] === pageType) {
      return;
    }

    // set page meta and type
    store.dispatch('dev/shopify/page/type', pageType);

    // load dev store order
    store.dispatch('dev/shopify/order/init');

    // mock page load
    ShopifyAdapterService.emmitPageLoad();
  }
}

export default new OrderPageService();
